import { render, staticRenderFns } from "./WorkPlanShiftsEdit.vue?vue&type=template&id=b1975406&"
import script from "./WorkPlanShiftsEdit.vue?vue&type=script&lang=js&"
export * from "./WorkPlanShiftsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports